import React, {useEffect, useState} from "react";

import axios from "config/axiosConfig";
import {useLocation, useNavigate} from "react-router-dom";
import dateFormat from "dateformat";

export default function Edit() {
    const [writingCategoryText, setWritingCategoryText] = useState('');
    const [writingIndustryText, setWritingIndustryText] = useState('');

    const [categories, setCategories] = useState([]);
    const [industries, setIndustries] = useState([]);

    const navigate = useNavigate();

    const handleAppendCategory = (e) => {
        const indexOf = categories.indexOf(writingCategoryText);

        if (writingCategoryText === '') {
            return;
        }

        if (indexOf >= 0) {
            setWritingCategoryText('');
            return;
        }

        setCategories([...categories, writingCategoryText]);
        setWritingCategoryText('');
    }

    const handleRemoveCategory = (index) => {
        const filtering = categories.filter((name, offset) => offset !== index);
        setCategories(filtering);
    }

    const handleAppendIndustry = (e) => {
        const indexOf = industries.indexOf(writingIndustryText);

        if (writingIndustryText === '') {
            return;
        }

        if (indexOf >= 0) {
            setWritingIndustryText('');
            return;
        }

        setIndustries([...industries, writingIndustryText]);
        setWritingIndustryText('');
    }

    const handleRemoveIndustry = (index) => {
        const filtering = industries.filter((name, offset) => offset !== index);
        setIndustries(filtering);
    }

    const requestUpdate = () => {
        const params = {};
        params.categories = categories;
        params.industries = industries;

        axios.put('/admin/policy-support/keywords', JSON.stringify(params))
            .then((res) => {
                alert('키워드가 수정되었습니다.');
                document.location.reload();
            });
    }

    useEffect(() => {
        axios.get(`/admin/policy-support/categories`)
            .then((res) => {
                const names = res.data.map(item => item.name);
                setCategories(names);
            });
        axios.get(`/admin/policy-support/industries`)
            .then((res) => {
                const names = res.data.map(item => item.name);
                setIndustries(names);
            });
    }, []);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">정책지원사업 / 키워드 관리</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">

                                        <div className="row">
                                            <div className="col-md-6">
                                                <div className="card">
                                                    <div className="card-header">
                                                        <span>카테고리</span>
                                                        <span style={{fontSize: '11px'}}>(클릭하면 삭제되요.)</span>
                                                        <button type="button" className="btn btn-outline-dark"
                                                                style={{marginLeft: '5px', float: 'right'}}
                                                                onClick={handleAppendCategory}>
                                                            추가
                                                        </button>
                                                        <input type="text" className="form-control col-3"
                                                               style={{display: 'inline-block', float: 'right'}}
                                                               onChange={e => setWritingCategoryText(e.target.value)}
                                                               value={writingCategoryText}
                                                        />

                                                    </div>
                                                    <div className="card-body">
                                                        {
                                                            categories && categories.map((item, index) => {
                                                                return (
                                                                    <button type="button" className="btn btn-outline-dark"
                                                                            style={{marginLeft: '10px', marginTop: '10px'}}
                                                                            onClick={() => handleRemoveCategory(index)}>
                                                                        {item}
                                                                    </button>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="col-md-6">
                                                <div className="card">
                                                    <div className="card-header">
                                                        <span>업종</span>
                                                        <span style={{fontSize: '11px'}}>(클릭하면 삭제되요.)</span>
                                                        <button type="button" className="btn btn-outline-dark"
                                                                style={{marginLeft: '5px', float: 'right'}}
                                                                onClick={handleAppendIndustry}>
                                                            추가
                                                        </button>
                                                        <input type="text" className="form-control col-3"
                                                               style={{display: 'inline-block', float: 'right'}}
                                                               onChange={e => setWritingIndustryText(e.target.value)}
                                                               value={writingIndustryText}/>
                                                    </div>
                                                    <div className="card-body">
                                                        {
                                                            industries && industries.map((item, index) => {
                                                                return (
                                                                    <button type="button" className="btn btn-outline-dark"
                                                                            style={{marginLeft: '10px', marginTop: '10px'}}
                                                                            onClick={() => handleRemoveIndustry(index)}>
                                                                        {item}
                                                                    </button>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row" style={{marginTop: '30px', marginBottom: '10px'}}>
                                            <div style={{margin: "0 auto"}}>
                                                <button type="button" className="btn btn-outline-dark"
                                                        onClick={e => navigate(-1)}>
                                                    취소
                                                </button>
                                                <button type="button" className="btn btn-outline-dark"
                                                        style={{marginLeft: '10px'}}
                                                        onClick={requestUpdate}>
                                                    저장
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    )
}